import { Component, Input, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { TableListPermissionComponent } from '../../../shared/components/table-list-permission/table-list-permission.component'
import {
  ProfileModel,
  SearchProfileModel,
} from '../../../core/models/profile.model'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { PermissionService } from '../../../core/services/permission/permission.service'
import { MatProgressBar } from '@angular/material/progress-bar'

@Component({
  selector: 'assign-permission',
  imports: [ReactiveFormsModule, TableListPermissionComponent, MatProgressBar],
  templateUrl: './assign-permission.component.html',
  styleUrl: './assign-permission.component.scss',
})
export class AssignPermissionComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private permissionService: PermissionService,
  ) {}

  @Input() profile: ProfileModel = new ProfileModel()

  loading: boolean = true
  formSearch: FormGroup = new FormGroup({})
  page: number = 1
  rows: number = 20
  numberRows: number = 0
  itemsList: any[] = []
  searchForm: SearchProfileModel = new SearchProfileModel()
  columns: any[] = [
    { keyColumn: 'screen', key: 'screen', description: 'Tela' },
    // {
    //   keyColumn: 'screen',
    //   key: 'screen',
    //   description: 'Tela',
    // },
    // {
    //   keyColumn: 'action',
    //   key: { edit: true, delete: false },
    //   description: 'Ações',
    // },
  ]

  ngOnInit() {
    // this.createForm()
    this.getPermissionbyProfile()
  }

  createForm(): void {
    this.formSearch = this.formBuilder.group({
      search: [''],
    })
  }

  search() {
    let search = this.formSearch.get('search')?.value
    this.page = 1
    this.uploadList()
  }

  uploadList() {
    if (this.searchForm.descricao) {
      this.searchProfile()
    } else {
      this.getPermissionbyProfile()
    }
  }

  pageChanged(page: number) {
    this.page = page
    if (this.searchForm.descricao) {
      this.searchProfile()
    } else {
      this.getPermissionbyProfile()
    }
  }

  getPermissionbyProfile() {
    if (this.profile.id) {
      this.loading = true
      this.permissionService
        .listPagedPermissionProfile(this.page, this.rows, this.profile.id)
        .subscribe({
          next: (response: any) => {
            this.itemsList = this.treatData(response.data)
            this.numberRows = response.data.length
          },
          error: (err: ResponseRequestModel) => {},
          complete: () => {
            this.loading = false
          },
        })
    }
  }

  treatData(list: any[]) {
    let newList: any[] = []

    const ordemNomeFuncao = [
      'listar',
      'pesquisar',
      'paginado',
      'pesquisar-paginado',
      'detalhe',
      'criar',
      'editar',
    ]

    for (let index: number = 0; index < list.length; index++) {
      const item: any = list[index]
      const key: any = item.nomeTela
      const indexNewList: number = newList.findIndex((ele) => {
        return ele.screen == key
      })
      if (indexNewList < 0) {
        newList.push({ screen: key, permissions: [item] })
      } else {
        newList[indexNewList].permissions.push(item)
      }
    }
    newList = newList.map((group) => {
      group.permissions.sort((a: any, b: any) => {
        const posA = ordemNomeFuncao.indexOf(a.nomeFuncao.toLowerCase())
        const posB = ordemNomeFuncao.indexOf(b.nomeFuncao.toLowerCase())
        const adjustedPosA = posA === -1 ? Number.MAX_VALUE : posA
        const adjustedPosB = posB === -1 ? Number.MAX_VALUE : posB

        return adjustedPosA - adjustedPosB
      })
      return group
    })
    return newList
  }

  searchProfile() {
    if (this.profile.id) {
      this.searchForm = new SearchProfileModel()
      this.loading = true
      this.permissionService
        .searchPagedPermissionProfile(this.page, this.rows, this.searchForm)
        .subscribe({
          next: (response: any) => {
            this.itemsList = response.data
            this.numberRows = response.totalItens
          },
          error: (err: ResponseRequestModel) => {},
          complete: () => {
            this.loading = false
          },
        })
    }
  }
}
